module.exports = __webpack_public_path__ + "img/sleeve_flounces_length.d82f7d45.png";